//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/reports';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            as_of_date: moment().format("MM/DD/YYYY"),
            headers: ['Unit', 'Resident', 'Past', { title: '0-30', filter: 'toCurrency' }, { title: '31-60', filter: 'toCurrency' }, { title: '61-90', filter: 'toCurrency' }, { title: '90+', filter: 'toCurrency' }, { title: 'Prepays', filter: 'toCurrency' }, { title: 'Balance', filter: 'toCurrency' }, 'AR Notes'],
            fields: ['Unit', 'Resident', 'Past', '0-30', '31-60', '61-90', '90+', 'Prepays', 'Balance', 'AR Notes'],
            items: [],
            showPastResidents: true,
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('ar-aging-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportArAgingToExcel', function () {
            return _this.exportToExcel();
        });
        Event.$on('exportArAgingToPdf', function () {
            return _this.exportToPdf();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ar-aging-report');
        Event.$off('exportArAgingToExcel');
        Event.$off('exportArAgingToPdf');
    },

    methods: {
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                exportExcel: true,
                as_of_date: this.as_of_date,
                showPastResidents: this.showPastResidents
            };

            this.createExport(data, BASE_URL + '/aging', 'ar-aging', '.xlsx');

            this.loading = false;
        },
        exportToPdf: function exportToPdf() {
            this.loading = true;

            var data = {
                exportPdf: true,
                as_of_date: this.as_of_date,
                showPastResidents: this.showPastResidents
            };

            this.createExport(data, BASE_URL + '/aging', 'ar-aging', '.pdf');

            this.loading = false;
        },
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.items = [];
            this.loading = true;
            axios.post(BASE_URL + '/aging', { as_of_date: this.as_of_date,
                showPastResidents: this.showPastResidents }).then(function (response) {
                _this2.items = response.data.result;
                _this2.loading = false;
            });
        }
    },
    computed: {
        filteredData: function filteredData() {
            if (this.showPastResidents) {
                return this.items;
            } else {
                return this.items.filter(function (resident) {
                    return resident['Past'] != 'Y';
                });
            }
        },
        totalZero: function totalZero() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['0-30'] || 0);
            }, 0)).toFixed(2);
        },
        totalThirty: function totalThirty() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['31-60'] || 0);
            }, 0)).toFixed(2);
        },
        totalSixty: function totalSixty() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['61-90'] || 0);
            }, 0)).toFixed(2);
        },
        totalNinety: function totalNinety() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['90+'] || 0);
            }, 0)).toFixed(2);
        },
        totalOwed: function totalOwed() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['Prepays'] || 0) + (cur['Balance'] || 0);
            }, 0)).toFixed(2);
        },
        totalPrepays: function totalPrepays() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['Prepays'] || 0);
            }, 0)).toFixed(2);
        },
        totalBalance: function totalBalance() {
            return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
                return prev + (cur['Balance'] || 0);
            }, 0)).toFixed(2);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/ArAgingReport.vue
// module id = TNyL
// module chunks = 0 1